import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import { GoChevronUp, GoChevronDown } from "react-icons/go";
import firstimg from "../../../Asset/why/handshake-after-interview-1-min.png";
import secondimg from "../../../Asset/why/Mask-group-1-min.png";
import thirdimg from "../../../Asset/why/Mask-group-2-min.png";
import fourthimg from "../../../Asset/why/Mask-group-3-min.png";
import fifthimg from "../../../Asset/why/young-businessman-communicating-with-his-colleagues-during-meeting-office-1-min.png";
import sixthimg from "../../../Asset/why/Mask-group-min.png";
import "./Whychoose.css";

const slides = [
  {
    img: fourthimg,
    title: "Excellence in Quality",
    mainTitle: "Setting The Standards For Satisfying Delivery",
    description:
      "At Codeffi, we aim to deliver exceptional quality in every aspect of our software development process. Our belief lies in people like you - the visionaries, the change-makers, and the creators who shape the future with groundbreaking ideas.",
  },
  {
    img: firstimg,
    title: "Enduring Trust",
    mainTitle: "Relationship Built to Lasts Forever",
    description:
      "We prioritize client satisfaction and transparency, fostering lasting trust. Our commitment to delivering outstanding digital solutions differentiates us from competitors. Around the clock, we tirelessly strive to ensure our clients' complete satisfaction.",
  },
  {
    img: fifthimg,
    title: "Leadership & Responsibility",
    mainTitle: "Guiding You With Accountable Expertise",
    description:
      "Industry leaders trust us as reliable software development partners because our leaders demonstrate strong leadership by taking full responsibility for the success of clients projects. With our track record of delivering innovative & reliable solutions.",
  },
  {
    img: sixthimg,
    title: "Embrace Technologies",
    mainTitle: "Technology Adaptive Thus Frontrunners of Innovations",
    description:
      "Our uniqueness lies in being a reliable partner, capable of adopting emerging technologies. We embrace emerging technologies to meet and exceed our clients' expectations and this guarantees that we build applications using state-of-the-art solutions.",
  },
  {
    img: secondimg,
    title: "Agile Approach",
    mainTitle: "Software Development That’s Faster Than Ever",
    description:
      "Agile is rooted in our DNA. At Codeffi, we apply agile methods seamlessly to our enterprise software development process. Our seamless and ideal approach to agile ensures that software development is easier and faster than ever.",
  },
  {
    img: thirdimg,
    title: "Expertise and Innovative Thinking",
    mainTitle: "Imaginative Intelligence To Serve Humankind",
    description:
      "Clients choose us for our commitment to excellence in software development. We thoroughly analyze every aspect of their project through detailed brainstorming sessions, never shying away from their concept. We are their reliable and dedicated partner.",
  },
];

const Whychooseus = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const goToNextSlide = () => {
    setCurrentIndex((currentIndex + 1) % slides.length);
  };

  const goToPrevSlide = () => {
    setCurrentIndex((currentIndex - 1 + slides.length) % slides.length);
  };

  return (
    <section className="why-choose-us-section">
      <Container>
        <div className="top-text-why-choose">
          <h2>
            WHY <span>CHOOSE US</span>
          </h2>
        </div>
        <div className="row w-100 mt-4">
          <div className="col-lg-7 col-md-7">
            <div className="splide">
              <div className="splide_track">
                <ul className="splide_list">
                  <li className="splide_slide">
                    <img src={slides[currentIndex].img} alt="slide" />
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-lg-5 col-md-5">
            <div className="splide-parent">
              <div className="splide-arrows">
                <button
                  className="splide-arrow splide-arrow-prev"
                  onClick={goToPrevSlide}
                >
                  <GoChevronDown className="arrow" />
                </button>
                <button
                  className="splide-arrow splide-arrow-next"
                  onClick={goToNextSlide}
                >
                  <GoChevronUp className="arrow" />
                </button>
              </div>
              <div className="splide__track">
                <ul className="splide__list">
                  <li className="splide__slide">
                    <div className="text_wrap">
                      <div className="first_text_wrap">
                        <h5 className="blue_title">
                          {slides[currentIndex].title}
                        </h5>
                        <h2 className="main_title">
                          {slides[currentIndex].mainTitle}
                        </h2>
                        <p className="para">
                          {slides[currentIndex].description}
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Whychooseus;
